export default {
  groupNamePlaceholder: 'Nombre del grupo',
  addMembers: 'Agrega a los participantes del grupo',
  searchPlaceholder: 'Buscar por Nombre o Correo Electrónico',
  editGroup: 'Editar grupo',
  submit: 'Aceptar',
  members: 'Participantes: {members}',
  addMember: 'Agregar participante',
  deleteGroup: 'Eliminar grupo',
  cancel: 'Cancelar',
  confirmRemove: '¿Estás seguro que quieres eliminar a estos integrantes?',
  confirmRemoveSubtitle: 'Al presionar eliminar se borrarán los siguientes integrantes:',
  confirmDelete: '¿Estás seguro que quieres eliminar este grupo?',
  confirmDeleteSubtitle: 'Al presionar eliminar se borrarán los siguientes grupos:'
}

export const en = {
  groupNamePlaceholder: 'Group name',
  addMembers: 'Add group participants',
  searchPlaceholder: 'Search by Name or Email',
  editGroup: 'Edit group',
  submit: 'Accept',
  members: 'Participants: {members}',
  addMember: 'Add participant',
  deleteGroup: 'Delete group',
  cancel: 'Cancel',
  confirmRemove: 'Are you sure you want to delete these members?',
  confirmRemoveSubtitle: 'Pressing delete will delete the following members:',
  confirmDelete: 'Are you sure you want to delete this group?',
  confirmDeleteSubtitle: 'Pressing delete will delete the following groups:'
}

export const ca = {
  groupNamePlaceholder: 'Nom del grup',
  addMembers: 'Afegeix els participants del grup',
  searchPlaceholder: 'Buscar per Nom o Correu Electrònic',
  editGroup: 'Editar grup',
  submit: 'Acceptar',
  members: 'Participants: {members}',
  addMember: 'Afegir participant',
  deleteGroup: 'Eliminar grup',
  cancel: 'Cancelar',
  confirmRemove: 'Estàs segur que vols eliminar aquests integrants?',
  confirmRemoveSubtitle: 'En prémer eliminar s\'esborraran els següents integrants:',
  confirmDelete: 'Estàs segur que vols eliminar aquest grup?',
  confirmDeleteSubtitle: 'En prémer eliminar s\'esborraran els següents grups:'
}
